export const Languages = [ 'ml', 'en', 'ta', 'hi' ];